import Vue from "vue"
import loadingComponent from "./Index.vue"

// 引入组件的.vue文件创建构造器
let LoadingConstructor = Vue.extend(loadingComponent)

// 渲染并且随后挂载
let instance = new LoadingConstructor().$mount()
document.body.appendChild(instance.$el)

instance.show = false

// 添加请求计数器
let requestCount = 0
// 添加防抖定时器
let hideTimer = null

let loading = {
    show() {
        requestCount++
        // 清除之前的隐藏定时器
        if (hideTimer) {
            clearTimeout(hideTimer)
            hideTimer = null
        }
        instance.show = true
    },
    hide() {
        requestCount--
        // 只有当所有请求都完成时才隐藏loading
        if (requestCount <= 0) {
            requestCount = 0
            // 添加小延迟，避免快速闪烁
            hideTimer = setTimeout(() => {
                instance.show = false
                hideTimer = null
            }, 100)
        }
    },
    // 添加强制隐藏方法，用于特殊情况
    forceHide() {
        requestCount = 0
        if (hideTimer) {
            clearTimeout(hideTimer)
            hideTimer = null
        }
        instance.show = false
    }
}

// 注册组件
export default {
    install() {
        if (!Vue.$loading) {
            Vue.$loading = loading
        }
        Vue.mixin({
            created() {
                this.$loading = Vue.$loading
            }
        })
    }
}